export default __webpack_public_path__ + "static/media/background_info.efc5abab.webp";